import { getAtlassianAccountWithRethrow } from '@atlassian/jira-atlassian-account/src/services/index.tsx';
import { fireErrorAnalytics } from '../common';
// If experiment is successful, export these from platform package and bump its version then consume from platform
// (or even better have a BE engineer implement DES in the BE during provisioning)
import { defaultInviteApiClient } from './temp-copied-from-platform';
import { makeAri } from './temp-copied-from-platform/utils.tsx';

interface GetDirectAccessSettingRequest {
	domain: string;
	productAri: string;
	setting: 'DIRECT_ACCESS' | 'REQUEST_ACCESS';
	roleAri?: string;
}

/**
 * @deprecated Please use getDomainWithSource instead of getDomain
 */
export const getDomain = async () => {
	try {
		const account = await getAtlassianAccountWithRethrow({ source: 'autoEnableDES' });
		return account?.email.split('@')[1];
	} catch (err: unknown) {
		// No need to fire error analytic here as it is fired already in
		// getAtlassianAccountWithRethrow - we can just check the source.
		return undefined;
	}
};

export const getDomainWithSource = async (source: string): Promise<string | undefined> => {
	try {
		const account = await getAtlassianAccountWithRethrow({ source });
		return account?.email?.split('@')[1];
	} catch (err: unknown) {
		return undefined;
	}
};

const getDirectAccessSetting = async (domain: string, cloudId: string) => {
	const request: GetDirectAccessSettingRequest = {
		domain,
		productAri: makeAri('jira-software', cloudId),
		setting: 'DIRECT_ACCESS',
	};

	try {
		return await defaultInviteApiClient.getDirectAccessSetting(request);
	} catch (err: unknown) {
		fireErrorAnalytics({
			attributes: { subject: 'getDirectAccessSetting' },
			error: err instanceof Error ? err : undefined,
			skipSentry: true,
		});
		throw err;
	}
};

export const getIsEligibleForDES = async (domain: string, cloudId: string) => {
	try {
		const { response: directAccessResponse } = await getDirectAccessSetting(domain, cloudId);

		if (
			'desPromotionEligible' in directAccessResponse &&
			directAccessResponse?.desPromotionEligible
		) {
			return directAccessResponse.desPromotionEligible;
		}
		return false;
	} catch (err: unknown) {
		return false;
	}
};

export const enableDES = async (domain: string, cloudId: string) => {
	const location = 'jira.onboarding';
	const product = 'jira-software';

	try {
		await defaultInviteApiClient.updateDirectAccessSettings({
			cloudId,
			product,
			domains: [domain],
			location,
		});
	} catch (err: unknown) {
		fireErrorAnalytics({
			attributes: { subject: 'enableDES' },
			error: err instanceof Error ? err : undefined,
			skipSentry: true,
		});
	}
};
